import { TrashIcon } from '@diligentcorp/atlas-react-icons';
import { IconButton } from '@mui/material';
import React from 'react';

type Props = {
  field: {
    id: string;
    handleDelete: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    reminderDays: React.JSX.Element;
  };
};

export function ReminderDaysField({ field }: Props): React.JSX.Element {
  return React.cloneElement(field.reminderDays, {
    actions: (
      <IconButton
        onClick={field.handleDelete}
        sx={{ p: 1, ml: 2 }}
        data-testid='delete'
      >
        <TrashIcon />
      </IconButton>
    ),
  });
}
